import React from "react";
import {
  FaRegHeart,
  FaHeart,
  FaBed,
  FaBath,
  FaCar,
  FaDoorOpen,
  FaMapMarkerAlt,
  FaArrowRight,
} from "react-icons/fa";

/**
 * Card único de imóvel usado pelas 4 páginas de listagem (Todos, Comprar,
 * Alugar, Lançamentos). Puramente apresentacional: recebe o imóvel já
 * filtrado e os callbacks de navegação/favorito prontos.
 */
function PropertyCard({ property, isFavorite, onToggleFavorite, onNavigate }) {
  const { imovelInfo, caracteristicas, informacoesComerciais, informacoesAdicionais } =
    property;

  const badges = [
    imovelInfo?.tipo,
    informacoesAdicionais?.exclusivo === "true"
      ? "Exclusivo"
      : imovelInfo?.construtora === "true"
      ? "Lançamento"
      : null,
  ].filter(Boolean);

  const bairro = imovelInfo?.bairro;

  const features = [
    caracteristicas?.quartos > 0 && {
      icon: <FaBed />,
      label: `${caracteristicas.quartos} Quartos`,
    },
    caracteristicas?.banheiros > 0 && {
      icon: <FaBath />,
      label: `${caracteristicas.banheiros} Banheiros`,
    },
    caracteristicas?.vagas > 0 && {
      icon: <FaCar />,
      label: `${caracteristicas.vagas} Vagas`,
    },
    caracteristicas?.suites > 0 && {
      icon: <FaDoorOpen />,
      label: `${caracteristicas.suites} Suítes`,
    },
  ].filter(Boolean);

  return (
    <a
      href={`/#/imovel/${imovelInfo.codigo}`}
      className="listing-card"
      draggable="false"
      onDragStart={(e) => e.preventDefault()}
      onClick={(e) => {
        if (
          e.button === 0 &&
          !e.metaKey &&
          !e.ctrlKey &&
          !e.shiftKey &&
          !e.altKey
        ) {
          e.preventDefault();
          onNavigate(imovelInfo.codigo);
        }
      }}
      target="_self"
      rel="noopener noreferrer"
    >
      <div className="listing-card__photo">
        {badges.length > 0 && (
          <div className="listing-card__badges">
            {badges.slice(0, 2).map((badge) => (
              <span key={badge} className="listing-card__badge">
                {badge}
              </span>
            ))}
          </div>
        )}

        <button
          type="button"
          className="listing-card__favorite"
          aria-label={isFavorite ? "Remover dos favoritos" : "Adicionar aos favoritos"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggleFavorite(property);
          }}
        >
          {isFavorite ? <FaHeart color="var(--verde)" /> : <FaRegHeart />}
        </button>

        <img
          src={property.imagesLinks?.[0] || "https://via.placeholder.com/300"}
          alt={`Imóvel ${imovelInfo?.codigo}`}
          loading="lazy"
          decoding="async"
          draggable="false"
        />
      </div>

      <div className="listing-card__body">
        <p className="listing-card__code">Cód. {imovelInfo?.codigo || "N/A"}</p>

        {bairro && (
          <p className="listing-card__location">
            <FaMapMarkerAlt /> <span>{bairro}</span>
          </p>
        )}

        <h3 className="listing-card__title">
          {imovelInfo?.titulo || "Endereço não informado"}
        </h3>

        {features.length > 0 && (
          <ul className="listing-card__features">
            {features.map((feature) => (
              <li key={feature.label}>
                {feature.icon} {feature.label}
              </li>
            ))}
          </ul>
        )}

        <div className="listing-card__footer">
          <div>
            <span className="listing-card__price-label">
              {informacoesComerciais?.tipoVenda}
            </span>
            <span className="listing-card__price">
              {informacoesComerciais?.valor || "N/A"}
            </span>
          </div>
          <span className="listing-card__cta">
            Ver imóvel <FaArrowRight aria-hidden="true" />
          </span>
        </div>
      </div>
    </a>
  );
}

export default PropertyCard;
